import { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "./dashboard/Navbar";
import Sidebar from "./dashboard/Sidebar";
import Calendar from "./calendar/Calendar";
import Kanban from "./kanbanBoard/Kanban";
import GlobalContext from "../context/GlobalContext";
import Analytics from "./analytics/Analytics";
import Homepage from "./homepage/Homepage";

const Home = () => {
  const { verified, setVerified, activeMenu, setActiveMenu, notifEvents } =
    useContext(GlobalContext);
  const navigate = useNavigate();
  const [homeNotifs, setHomeNotifs] = useState([]);

  async function verify() {
    try {
      const res = await fetch(
        "http://opti-plan-2024-backend.vercel.app/auth/verify",
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parseRes = await res.json();

      setVerified(parseRes.auth);
    } catch (err) {
      console.error(err.message);
    }
  }

  useEffect(() => {
    verify();
  }, []);

  const showNotif = () => {
    console.log(notifEvents);
  };

  useEffect(() => {
    setHomeNotifs(
      notifEvents.map((event) => {
        toast.info("Upcoming event: " + `${event.title}`, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          transition: Slide,
        });
      })
    );
  }, [notifEvents]);

  if (verified) {
    return (
      <div>
        {activeMenu && (
          <div
            className="fixed w-full h-full bg-neutral-950/50 z-50"
            onClick={() => setActiveMenu(false)}
          ></div>
        )}
        <div className="flex relative bg-neutral-900">
          {activeMenu ? (
            <div className="w-72 z-50 fixed">
              <Sidebar />
            </div>
          ) : (
            <div className="w-0 z-50">
              <Sidebar />
            </div>
          )}
          <div
            className={`bg-main-bg min-h-screen w-full ${
              activeMenu ? "" : "flex-2"
            }`}
          >
            <div className="fixed md:static bg-main-bg navbar w-full">
              <Navbar />
            </div>
            <div>
              <Routes>
                <Route path="/home" element={<Homepage />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/kanban" element={<Kanban />} />
                <Route path="/analytics" element={<Analytics />} />
              </Routes>
            </div>
            <div>
              {homeNotifs}
              <ToastContainer stacked />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <Fragment>
        <div className="h-screen w-screen flex items-center justify-center bg-neutral-900">
          <div className="grid grid-rows-2 justify-items-center">
            <h1 className="text-neutral-200">
              Session has expired
            </h1>
            <button 
              className="text-center text-blue-500 underline" 
              onClick={() => navigate("/login")}
            >
              Sign in
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
};

export default Home;
